import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IndustryOrganizationsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader
        tabName={t('pageIntegrations.tabNames.industry-organizations')}
      />
      <IntegrationsTable
        category={IntegrationCategory.INDUSTRY_ORGANIZATIONS}
      />
    </section>
  );
};

export default IndustryOrganizationsTab;
